export const LERP_DRAG = 0.9;
export const LERP_IDLE = 0.12;
export const LERP_GOTO = 0.068;
export const INERTIA_FRICTION = 0.94;
export const INERTIA_MIN = 0.45;

export const DRAG_SENSITIVITY = 0.75;

export const SCALE_DECAY = 0.4;
export const SCALE_MIN = 0.05;

export const INITIAL_SLIDE_INDEX = 8;

export const INERTIA_START_THRESHOLD = 2.2;

export const SETTLING_EPSILON_PX = 0.2;

export const POINTER_VELOCITY_BLEND_PREV = 0.35;
export const POINTER_VELOCITY_BLEND_NEW = 0.65;

export const POINTER_VELOCITY_MS_TO_FRAME = 16;

export const SLIDE_Z_INDEX_BASE = 80;
export const SLIDE_Z_INDEX_DISTANCE_CAP = 8;
export const SLIDE_Z_INDEX_STEP = 9;

export const TEAM_SLIDE_SELECTOR = '[data-team-slide]' as const;
